const reviewdata = [
  {
    id: 1,
    name: 'Neelaksh Singh',
    city: 'Delhi',
    desc: 'Flattered with availability of well maintained cars',
  },
  {
    id: 2,
    name: 'Riya Shukla',
    city: 'Delhi',
    desc: "Booked a XUV with unlimited kms, very happy with Wheelit's service",
  },
  {
    id: 3,
    name: 'Ravi Singh',
    city: 'Mumbai',
    desc: 'Booked a car for a family trip which was very comfortable and in great condition',
  },
  {
    id: 4,
    name: 'Neetu Singh',
    city: 'Bangalore',
    desc: 'Driving on your own is like breath of fresh air. You are in control',
  },
]
export default reviewdata
